// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"381":"04412b18","389":"89bbda90","506":"716eb9b2","601":"8ec22864","741":"efc4fd8b","771":"788f15c2","891":"e779784a","990":"79354398"}[chunkId] + ".js";
};